/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-17 16:29:25
 */
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import {
  getDrugQualityFileDetailAsync,
  getDrugQualityFileSubmitAsync,
} from './drugQualityFileSlice'
import { RecipeItemInput } from '../../treatment/editor/components/RecipeItemInput'
import { ItemCompletionType } from '../../completion/completionSlice'
import { SupplierModal } from '../../savebusiness/modal'
import { QuestionCircleTwoTone } from '@ant-design/icons'
import { setDetail } from '../../durgsystem/durgsystemSlice'
import { getQualityControlCategory } from '../../../models/commodity'

const { Option } = Select

export const AddOrEditFormModal = (props: {
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [selectData, setSelectData] = useState<any>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [tenantSupplierId, setTenantSupplierId] = useState('')

  const [flag, setFlag] = useState<any>()

  const [detail, setDetail] = useState<any>()

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 },
  }

  const getDetail = () => {
    dispatch(getDrugQualityFileDetailAsync(props?.id))
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        setSelectData(v)
        form.setFieldsValue({
          ...v,
          appearanceQuality:
            v?.appearanceQuality != -1 ? v?.appearanceQuality?.toString() : '',
        })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      } else {
        form.setFieldsValue({
          appearanceQuality: '1',
        })
      }
    } else {
      form.resetFields()
      setSelectData('')
      setTenantSupplierId('')
    }
  }, [props.isModalVisible, props?.id])

  return (
    <>
      <Modal
        width={1200}
        title={props?.id ? '编辑数据' : '添加数据'}
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            setConfirmLoading(true)
            const params = props?.id
              ? {
                  ...detail,
                  ...vs,
                  id: detail?.id,
                  tenantMaterialsCatalogId:
                    selectData?.id || detail?.tenantMaterialsCatalogId,
                  tenantSupplierId:
                    tenantSupplierId || detail?.tenantSupplierId,
                  genericName: selectData?.genericName || detail?.genericName,
                }
              : {
                  ...vs,
                  tenantMaterialsCatalogId: selectData?.id,
                  tenantSupplierId: tenantSupplierId,
                  genericName: selectData?.genericName,
                }
            if (vs?.name == selectData?.name) {
              dispatch(getDrugQualityFileSubmitAsync({ ...params }))
                .then(unwrapResult)
                .then((v: any) => {
                  notification.success({
                    message: '操作成功',
                  })
                })
                .finally(() => {
                  props?.onOk()
                  setConfirmLoading(false)
                })
            } else {
              notification.info({
                message: '商品名称错误，请修改后再保存',
              })
              setConfirmLoading(false)
            }
          }}
        >
          <Row>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='商品名'
                name='name'
                rules={[
                  {
                    required: true,
                    message: '商品名不能为空',
                  },
                ]}
              >
                <RecipeItemInput
                  noSetting={true}
                  // isRestrictUser={1} //是否限制用户
                  type={ItemCompletionType.Material}
                  filters={false}
                  useSpecifiedBatch={true}
                  onSelect={(v: any) => {
                    setSelectData(v)
                    form.setFieldsValue({
                      name: v?.name,
                      putWay: getQualityControlCategory(v?.putCategory),
                      supplierName: v?.normalGysName,
                      remark: v?.remark,
                    })
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='储存条件' name='putWay'>
                <Input placeholder='储存条件' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='外观质量' name='appearanceQuality'>
                <Select placeholder='外观质量' allowClear>
                  <Option value='1'>合格</Option>
                  <Option value='0'>不合格</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='规范情况' name='normSituation'>
                <Input placeholder='规范情况' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='进货质量评审情况'
                name='instockSituation'
              >
                <Input placeholder='进货质量评审情况' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='顾客质量评价' name='customRemark'>
                <Input placeholder='顾客质量评价' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} name='supplierName' label='供应商'>
                <Input
                  size='middle'
                  allowClear
                  onClick={() => {
                    setFlag(0)
                    setIsModalVisible(true)
                  }}
                  addonAfter={
                    <>
                      <Popover
                        content={
                          <div>
                            <p>
                              设置常用供应商后，您可以通过入库/申领/采购等环节设置的供应商快速找到这个药品。
                            </p>
                          </div>
                        }
                        placement='top'
                        title='说明'
                      >
                        <QuestionCircleTwoTone />
                      </Popover>
                    </>
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='备注' name='remark'>
                <Input placeholder='备注' />
              </Form.Item>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              loading={confirmLoading}
              type='primary'
              onClick={() => {
                form.submit()
              }}
              style={{ marginRight: '10px' }}
            >
              确定
            </Button>
            <Button
              type='primary'
              ghost
              style={{ marginRight: '10px' }}
              onClick={() => {
                props?.onCancel()
              }}
            >
              取消
            </Button>
          </Row>
        </Form>
      </Modal>
      <SupplierModal
        supplierCategory={flag}
        visible={isModalVisible}
        switchModal={() => {
          setIsModalVisible(false)
          setFlag('')
        }}
        onOk={() => {
          setIsModalVisible(false)
          setFlag('')
        }}
        onCancel={() => {
          setIsModalVisible(false)
          setFlag('')
        }}
        onRecord={(record: any) => {
          setTenantSupplierId(record.id)
          form.setFieldsValue({
            supplierName: record.companyName,
          })
        }}
      />
    </>
  )
}
